import { render, staticRenderFns } from "./upload-certificate.vue?vue&type=template&id=2f6d9fea&scoped=true"
import script from "./upload-certificate.vue?vue&type=script&lang=js"
export * from "./upload-certificate.vue?vue&type=script&lang=js"
import style0 from "./upload-certificate.vue?vue&type=style&index=0&id=2f6d9fea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d9fea",
  null
  
)

export default component.exports